import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AuthModal from './AuthModal';
import { useAuthContext } from '../../../context/AuthContext';

/** MYM theme background: gradient + radial glows (matches Mind Your Music page). */
const MYM_BG = {
  minHeight: '100vh',
  background: [
    'radial-gradient(circle at 20% 80%, rgba(0,255,255,0.12) 0%, transparent 40%)',
    'radial-gradient(circle at 80% 20%, rgba(255,0,255,0.12) 0%, transparent 40%)',
    'radial-gradient(circle at 50% 50%, rgba(255,0,255,0.08) 0%, transparent 55%)',
    'linear-gradient(180deg, #0a0015 0%, #1a0033 50%, #0a0015 100%)',
  ].join(', '),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  p: 2,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'radial-gradient(ellipse 80% 50% at 50% 0%, rgba(255,0,255,0.15) 0%, transparent 50%)',
    pointerEvents: 'none',
  },
};

/**
 * Full-page signup (MYM theme). Same auth content as AuthModal in register mode.
 * After success redirects to /mindyourmusic.
 */
const SignupPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthContext();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/mindyourmusic', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSuccess = () => {
    navigate('/mindyourmusic', { replace: true });
  };

  const handleClose = () => {
    navigate('/', { replace: true });
  };

  return (
    <Box sx={MYM_BG}>
      <AuthModal
        open={true}
        onClose={handleClose}
        onSuccess={handleSuccess}
        initialMode="register"
        forceFullScreen={true}
      />
    </Box>
  );
};

export default SignupPage;
